import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router } from '@angular/router';
import { HotToastService } from '@ngxpert/hot-toast';
import * as Sentry from '@sentry/angular';
import { BehaviorSubject, of, Subscription } from 'rxjs';
import { delay, map } from 'rxjs/operators';

import { StateService } from '../state/state.service';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard {
  constructor(
    private auth: AuthService,
    private state: StateService,
    private router: Router,
    private toast: HotToastService,
  ) {}

  public loading$ = new BehaviorSubject(false);

  loader$: Subscription;

  canActivate(route: ActivatedRouteSnapshot) {
    this.loader$ = of(null)
      .pipe(delay(200))
      .subscribe((x) => this.loading$.next(true));

    const res = this.auth.profile().pipe(
      map((profile) => {
        this.loader$.unsubscribe();
        this.loading$.next(false);

        Sentry.setUser({
          email: profile?.email,
          username: profile?.username,
          id: profile?.id,
        });

        if (!profile) {
          return this.router.parseUrl('/login');
        }

        return !!profile;
      }),
    );

    return res;
  }

  cancelPageAndLogout() {
    if (this.loader$) {
      this.loader$.unsubscribe();
    }
    this.loading$.next(false);
    this.auth.logout(true);
  }
}
